/* Visar korrekta och felaktiga ord som valts. */
import React from "react";

class WordList extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            cheated_words: []
        };
    }

    cheat = (word) => {
        this.setState({
            cheated_words: [...this.state.cheated_words, word]
        });
    }

    render() {
        const chip = {
            display: "inline-block",
            borderRadius: "10px",
            border: "2px solid white",
            padding: "0 4px",
            margin: "3px",
            overflow: "auto"
        }
        const found = {
            ...chip,
            background: "green"
        };
        const notfound = {
            ...chip,
            background: "red"
        };
        const cheated = {
            ...chip,
            background: "gray"
        };
        const failed = {
            ...chip,
            background: "gray",
            textDecorationLine: 'line-through',
            textDecorationStyle: 'solid'
        };
        let points = this.props.found_words.length;
        this.props.found_words.forEach((word, idx) => {
            if (this.state.cheated_words.includes(word))
                points--;
        }
        );
        return (
            <div>
                <h2>Hittat {points} ord av {this.props.correct_words.length}</h2>
                {
                    this.props.correct_words.map((item, idx) => {
                        if (this.state.cheated_words.includes(item)) {
                            return (<span style={cheated} key={idx}> {item.toUpperCase()}</span>)
                        }
                        if (this.props.found_words.includes(item)) {
                            return (<span style={found} key={idx}> {item.toUpperCase()}</span>)
                        }
                        return (<span style={notfound} key={idx} onClick={() => this.cheat(item)}> {item.replace(/./g, '*')}</span>)
                    })
                }
                <br />
                {
                    this.props.failed_words.map((item, idx) => {
                        return (<span style={failed} key={"fail"+idx}> {item.toUpperCase()}</span>)
                    })
                }
            </div >
        );
    }
}

export default WordList;